// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"264":"f511a763","645":"db25d462"}[chunkId] + ".css";
};